<div [ngStyle]="{'height': chartHeight + 'px'}" >
  <canvas baseChart
    [data]="barChartData"
    [options]="barChartOptions"
    [type]="chartType">
  </canvas>
</div>
